// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"8c40a5fe","239":"1d024a89","455":"70db23af","977":"61a76bff"}[chunkId] + ".chunk.js";
};